import { Typography } from '@mui/material'
import { styled } from '@mui/system'

import { DefaultElementProps } from 'common/interfaces'
import { useTemplate } from 'utils/hook'

import { SummaryView as SummaryViewProps } from './interface'

const SummaryViewWrapper = styled('div')(({ theme }) => ({
  padding: 24,
  width: '100%',
  background: '#F7F7F7',

  display: 'flex',
  flexDirection: 'column',
  rowGap: 6,
}))

const SummaryViewItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

const SummaryViewLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: 'text.secondary',
}))

const SummaryViewValue = styled(Typography)(({ theme }) => ({
  color: 'text.primary',
  whiteSpace: 'pre-wrap',
}))

export default function SummaryView({ rows }: SummaryViewProps & DefaultElementProps): JSX.Element {
  const template = useTemplate()

  return (
    <SummaryViewWrapper className="summary-view-wrap">
      {rows.map((row) => (
        <SummaryViewItem className="summary-view-inner" key={row.label}>
          <SummaryViewLabel className="summary-view-label">{template(row.label)}</SummaryViewLabel>
          <SummaryViewValue className="summary-view-value">{template(row.value)}</SummaryViewValue>
        </SummaryViewItem>
      ))}
    </SummaryViewWrapper>
  )
}
